import { render, staticRenderFns } from "./NewWebsiteWizzard.vue?vue&type=template&id=54c5bec9&scoped=true"
import script from "./NewWebsiteWizzard.vue?vue&type=script&lang=js"
export * from "./NewWebsiteWizzard.vue?vue&type=script&lang=js"
import style0 from "./NewWebsiteWizzard.vue?vue&type=style&index=0&id=54c5bec9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c5bec9",
  null
  
)

export default component.exports